import React from "react"
import {
  NieuwsEdgeFragment,
  OverviewDataFragment,
  wpNieuwsFragment,
} from "../../__generated__/graphql-gatsby"
import NextAndPrev from "../nextAndPrev"
import PageBuilder from "../pageBuilder"
import Spacer from "../pageBuilder/spacer"
import SEO from "../SEO"
import ShareBtn from "../shareBtn"

interface IProps {
  data: Maybe<wpNieuwsFragment>
  next?: Maybe<NieuwsEdgeFragment>
  previous?: Maybe<NieuwsEdgeFragment>
  overviewData?: Maybe<Array<Maybe<OverviewDataFragment>>>
  sessionKey: string
}

const NieuwsComponent: React.FC<IProps> = ({
  data,
  next,
  previous,
  overviewData,
  sessionKey,
}) => {
  const { seo, page_builder, uri } = { ...data }

  return (
    <>
      <SEO
        title={seo?.title}
        description={seo?.metaDesc}
        ogTitle={seo?.opengraphTitle}
        ogDescription={seo?.opengraphDescription}
        img={{
          url: seo?.opengraphImage?.sourceUrl,
          alt: seo?.opengraphImage?.altText,
          width: seo?.opengraphImage?.mediaDetails?.width,
          height: seo?.opengraphImage?.mediaDetails?.height,
        }}
        siteName={seo?.opengraphSiteName}
        canonical={uri}
      />
      <ShareBtn title={String(seo?.title)} />
      <Spacer height={56} />
      <PageBuilder
        blocks={page_builder?.pageBuilder}
        overviewData={overviewData}
        sessionKey={sessionKey}
      />
      <NextAndPrev next={next} previous={previous} />
    </>
  )
}

export default NieuwsComponent
